import { Nullable } from 'global';
import { CloseReason } from '../types';
import { GetCloseReasonsResponse } from '../api';

class CloseReasonsMapper {
  processReasonsToFormValues(response: Nullable<GetCloseReasonsResponse>): Record<'won' | 'lost', CloseReason[]> {
    if (!response || !response.bpf.result.list.length) {
      return {
        won: [],
        lost: [],
      };
    }

    return response.bpf.result.list.reduce<Record<'won' | 'lost', CloseReason[]>>(
      (acc, reason) => {
        acc[reason.type.toLowerCase() as 'won' | 'lost'].push(reason);

        return acc;
      },
      { won: [], lost: [] }
    );
  }
}

export const closeReasonsMapper = new CloseReasonsMapper();
